import { Phone, MessageCircle } from "lucide-react";
import { BRAND } from "../data/siteData";

export const FloatingCTA = () => (
    <div
        data-testid="floating-contact"
        className="fixed bottom-4 right-4 z-50 flex flex-col gap-2.5 sm:bottom-6 sm:right-6"
    >
        <a
            href={BRAND.phones[0].tel}
            data-testid="floating-call-button"
            aria-label="Call Eway Fiber Net customer care"
            className="flex items-center gap-2 rounded-full bg-[#E61C24] px-4 py-3 text-sm font-bold text-white shadow-[0_8px_28px_rgba(230,28,36,0.5)] transition-[transform,background-color] duration-200 hover:scale-105 hover:bg-[#C7151C]"
        >
            <Phone className="h-4 w-4" />
            <span>Call</span>
        </a>
        <a
            href={BRAND.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="floating-whatsapp-button"
            aria-label="Chat with Eway Fiber Net on WhatsApp"
            className="flex items-center gap-2 rounded-full bg-[#1FAF54] px-4 py-3 text-sm font-bold text-white shadow-[0_8px_28px_rgba(31,175,84,0.45)] transition-[transform,background-color] duration-200 hover:scale-105 hover:bg-[#178f43]"
        >
            <MessageCircle className="h-4 w-4" />
            <span>WhatsApp</span>
        </a>
    </div>
);
